import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useDistrictBulkProcessingConfigGet = (options) => {
  const requestUrl = `${API_BASE_URL}/api/v2/district-bulk-processing-configuration/`;
  return useRestQuery(requestUrl, options);
};

export default useDistrictBulkProcessingConfigGet;
